import jMoment from "moment-jalaali";
import React, { useEffect, useState } from "react";
import { DateTimePicker } from "@mui/x-date-pickers";
import { digitsFaToEn } from "@persian-tools/persian-tools";

const DateTimeWidget = (props) => {
  const { value, schema, onChange } = props;
  const [date, setDate] = useState(null);
  const [flag, setFlag] = useState(true);

  const formattedDate = (x) =>
    digitsFaToEn(jMoment(x).format("YYYY-MM-DD HH:mm"));

  const onAccept = (date) => {
    setFlag(false);
    setDate(formattedDate(date));
    onChange(formattedDate(date));
  };

  useEffect(() => {
    if (flag && value) {
      return onAccept(formattedDate(value));
    }
  }, [value]);

  return (
    <DateTimePicker
      onAccept={onAccept}
      label={schema.title}
      sx={{ direction: "rtl" }}
      value={date && jMoment(date)}
      slotProps={{
        desktopPaper: {
          dir: "rtl",
        },
        mobilePaper: {
          dir: "rtl",
        },
      }}
    />
  );
};

export default DateTimeWidget;
